import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@savvy-kit/components/select';
import { cn } from '@savvy-kit/lib/utils';

export type DataTablePageSizeProps = {
  pageSize: number;
  onPageSizeChange: (pageSize: number) => void;
  pageSizeOptions?: number[];
  className?: string;
  label?: string;
};

export function DataTablePageSize({
  pageSize,
  onPageSizeChange,
  pageSizeOptions = [10, 20, 50, 100],
  className,
  label = 'Rows per page',
}: DataTablePageSizeProps) {
  return (
    <div className={cn('flex items-center gap-2', className)}>
      <p className="text-sm">{label}</p>
      <Select
        value={`${pageSize}`}
        items={pageSizeOptions.map((opt) => ({ value: `${opt}`, label: String(opt) }))}
        onValueChange={(value) => {
          onPageSizeChange(Number(value));
        }}
      >
        <SelectTrigger className="data-[size=default]:h-9">
          <SelectValue placeholder={pageSize} />
        </SelectTrigger>
        <SelectContent side="top">
          {pageSizeOptions.map((opt) => (
            <SelectItem key={opt} value={`${opt}`}>
              {opt}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
